import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import * as React from "react";
import MenuBar from "components/mnl/global/menuBar";
import { theme } from "components/mnl/global/theme";
import GetAllClientType from "components/mnl/admin/clientType/getAllClientType";
import V2SessionTimeout from "components/mnl/global/v2SessionTimeout";
import TableLayout from "views/mnl/layout/tableLayout";

const ClientTypePage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <MenuBar pageName={"Client Type"} />
        <TableLayout>
          <GetAllClientType />
        </TableLayout>
      </Box>
      <V2SessionTimeout />
    </ThemeProvider>
  );
};
export default ClientTypePage;
